import React from 'react';
import { GiftIcon } from 'lucide-react';
import { SectionBadge } from '../SectionBadge';
import { Reveal } from '../Reveal';
import { BONOS, PRICING } from '../../data/content';
export function Bonos() {
  return <section className="w-full px-5 py-12 sm:py-16" data-id="element-15" data-mp="1hipusxodledw">
      <div className="mx-auto max-w-5xl" data-id="element-16" data-mp="1ckobcbn1fd1w">
        <Reveal className="text-center" data-id="element-17" data-mp="1clpoqmrj0bms">
          <SectionBadge data-id="element-18" data-mp="1cilfhaz7epp9">Regalo incluido</SectionBadge>
          <h2 className="mx-auto mt-5 max-w-2xl font-display text-2xl leading-tight text-snow sm:text-4xl" data-id="element-19" data-mp="ow529tw5yw8r">
            Además recibís <span className="u-lime" data-id="element-20" data-mp="jxldllq6r6cp">5 bonos gratis</span>
          </h2>
          <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-snow-muted sm:text-base" data-id="element-21" data-mp="ylye8w07xddj">
            Material extra para dar clases infantiles, organizar tu año y{' '}
            <strong className="font-bold text-snow" data-id="element-22" data-mp="642hc6chotsp">llenar tus horarios</strong>.
          </p>
        </Reveal>

        <div className="mt-8 grid gap-3.5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-23" data-mp="16ardhvenhr5">
          {BONOS.map((bono, index) => <Reveal key={bono.n} delay={index % 3 * 80} as="article" data-id="element-24" data-mp="2z9mgap7zhsvh" data-mpi={index}>
              <div className="flex h-full flex-col rounded-2xl border border-white/10 bg-ink/90 p-5" data-id="element-25" data-mp="348z3jb2rp1yl">
                <div className="flex items-center justify-between" data-id="element-26" data-mp="38zyvs30xyvur">
                  <span className="text-[10px] font-extrabold uppercase tracking-[0.18em] text-snow-dim" data-id="element-27" data-mp="3d1su44nnznrr">
                    Bono {bono.n}
                  </span>
                  <span className="inline-flex items-center gap-1 rounded-full bg-lime px-2.5 py-1 text-[10px] font-extrabold uppercase tracking-wide text-ink" data-id="element-28" data-mp="2gd4hjnupwspq">
                    <GiftIcon className="h-3 w-3" aria-hidden="true" data-id="element-29" data-mp="2pbyitrizu79m" /> Gratis
                  </span>
                </div>

                <img src={bono.mockup} alt={`Portada del bono ${bono.n}: ${bono.title}`} width={144} height={192} sizes="108px" loading="lazy" fetchPriority="low" decoding="async" className="mx-auto mt-4 h-32 w-auto object-contain" data-id="element-30" data-mp="2uc42akf40ngm" />

                <h3 className="mt-4 text-sm font-bold leading-snug text-snow" data-id="element-31" data-mp="21mdciqhiyawr">{bono.title}</h3>
                <p className="mt-1.5 flex-1 text-sm leading-relaxed text-snow-muted" data-id="element-32" data-mp="2flwa4pcpm3ut">{bono.desc}</p>
                <p className="mt-3.5 text-xs font-semibold text-snow-dim" data-id="element-33" data-mp="2anup3yvq3ugp">
                  Valor <span className="line-through" data-id="element-34" data-mp="1myij17vp02im">{bono.price}</span> ·{' '}
                  <span className="text-lime" data-id="element-35" data-mp="1hz5v0jt34peg">hoy incluido</span>
                </p>
              </div>
            </Reveal>)}
        </div>

        <Reveal delay={110} className="mt-6 text-center" data-id="element-36" data-mp="1wov1mujy5lm4">
          <p className="inline-block rounded-full border border-white/10 bg-ink/90 px-6 py-3 text-sm font-bold text-snow" data-id="element-37" data-mp="1rwjyzjxtnlpv">
            Bonos valuados en <span className="text-snow-dim line-through" data-id="element-38" data-mp="145ejj5vsmvg3">{PRICING.bonusValueOld}</span>{' '}
            <span className="text-lime" data-id="element-39" data-mp="z7wbdhplok95">— incluidos sin costo</span>
          </p>
        </Reveal>
      </div>
    </section>;
}